import { React } from 'react';
import styled from 'styled-components';

import DefaultLogoPath from '../../image/DefaultLogo.png';
import PictureDeleteButton from '../../image/PictureDeleteButton.png'

function LogoView(props) {
  const { data, index, onClickDeleteButton } = props;

  return (
    <TopLevelWrapper>
      <Logo src={data ? data : DefaultLogoPath}/>
      <ExitButton src={PictureDeleteButton} onClick={() => onClickDeleteButton(index)}/>
    </TopLevelWrapper>
  )
}

export default LogoView;

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;
`;

const Logo = styled.img`
  width: 99px;
  height: 99px;

  border-radius: 15px;

  object-fit: cover;
`;

const ExitButton = styled.img`
  position: absolute;
  width: 32px;
  height: 32px;

  border-radius: 32px;

  object-fit: cover;

  :hover {
    cursor: pointer;
  }
`;